/* SIACSKIN Wissensbereich: Suche mit Vorschlaegen.
   Themen kommen aus dem Markup (sofort verfuegbar), Fragen und Antworten aus dem Abschnitt
   siac-wissen-index (wird beim ersten Antippen des Suchfelds geladen). */
(function () {
  'use strict';
  if (window.__siacWissenSuche) return;
  window.__siacWissenSuche = true;
  var SELF = (document.currentScript && document.currentScript.src) || '';

  /* ---------- Normalisierung ---------- */
  var MAP = { 'ß': 'ss', 'æ': 'ae', 'œ': 'oe', 'ø': 'o', 'ł': 'l', 'đ': 'd', 'ð': 'd', 'þ': 'th', 'ı': 'i', 'ς': 'σ',
    'أ': 'ا', 'إ': 'ا', 'آ': 'ا', 'ٱ': 'ا', 'ى': 'ي', 'ی': 'ي', 'ئ': 'ي', 'ک': 'ك', 'ة': 'ه', 'ؤ': 'و' };
  var MAP_RE = /[ßæœøłđðþıςأإآٱىیئکةؤ]/g;
  var STRIP_RE = /[̀-ͯ҃-֑҇-ׇֽֿׁׂׅׄؐ-ًؚ-ٰٟۖ-ۜ۟-۪ۤۧۨ-ۭـ़‌‍‎‏­]/g;
  var WORD_RE = /[\p{L}\p{N}\p{M}]+/gu;
  var CJK_RE = /[぀-ヿ㐀-鿿가-힯]/;
  var lang = 'de';

  function norm(s) {
    s = String(s || '').toLowerCase().normalize('NFD').replace(STRIP_RE, '').normalize('NFC').replace(MAP_RE, function (c) { return MAP[c]; });
    if (lang === 'de') s = s.replace(/ae/g, 'a').replace(/oe/g, 'o').replace(/ue/g, 'u');
    return s;
  }
  function tokens(s) { return norm(s).match(WORD_RE) || []; }

  /* ---------- Sinnverwandte Begriffe und haeufige Schreibweisen ---------- */
  var GROUPS = {
    de: [
      ['kosten', 'kostet', 'preis', 'preise', 'teuer', 'investition', 'anschaffungskosten'],
      ['finanzierung', 'finanzieren', 'leasing', 'leasen', 'mietkauf', 'rate', 'raten', 'ratenkauf', 'ratenzahlung', 'mieten'],
      ['schmerz', 'schmerzen', 'schmerzhaft', 'weh', 'wehtun', 'schmerzfrei'],
      ['nebenwirkung', 'nebenwirkungen', 'risiko', 'risiken', 'gefahrlich', 'gefahr', 'verbrennung', 'verbrennungen'],
      ['dauer', 'dauert', 'lange', 'sitzungen'],
      ['garantie', 'gewahrleistung'],
      ['schulung', 'schulungen', 'kurs', 'kurse', 'ausbildung', 'training', 'einweisung', 'fachkunde', 'nisv', 'akademie'],
      ['haarentfernung', 'enthaarung', 'epilation', 'haare', 'dauerhafte'],
      ['tattoo', 'tattoos', 'tatowierung', 'tatowierungen', 'tattooentfernung'],
      ['falten', 'faltchen', 'hautalterung', 'hautverjungung', 'antiaging', 'straffung'],
      ['pickel', 'akne', 'unreinheiten', 'mitesser'],
      ['narben', 'narbe', 'aknenarben'],
      ['fett', 'fettpolster', 'fettabbau', 'korperformung', 'kryolipolyse', 'abnehmen'],
      ['cellulite', 'orangenhaut', 'zellulitis'],
      ['besenreiser', 'aderchen', 'couperose', 'rosazea', 'rotungen'],
      ['pigmentflecken', 'altersflecken', 'sonnenflecken', 'melasma', 'pigmente', 'flecken'],
      ['wartung', 'service', 'reparatur', 'ersatzteile'],
      ['kaufen', 'kauf', 'anschaffen', 'anschaffung', 'bestellen'],
      ['zulassung', 'zertifikat', 'zertifizierung', 'ce', 'mdr', 'medizinprodukt'],
      ['sonne', 'sonnenbad', 'solarium', 'braune', 'gebraunt', 'sommer'],
      ['schwanger', 'schwangerschaft', 'stillzeit', 'stillen'],
      ['intim', 'intimbereich', 'bikini', 'bikinizone'],
      ['manner', 'mann', 'bart', 'herren'],
      ['studio', 'kosmetikstudio', 'laserstudio', 'praxis', 'institut'],
      ['rentabel', 'rentabilitat', 'umsatz', 'gewinn', 'amortisation', 'lohnt', 'verdienen'],
      ['kuhlung', 'kuhlen', 'kalte', 'kuhlgerat'],
      ['nachsorge', 'pflege', 'heilung', 'danach', 'nachbehandlung']
    ],
    en: [
      ['cost', 'costs', 'price', 'prices', 'pricing', 'expensive', 'investment'],
      ['financing', 'finance', 'leasing', 'lease', 'instalment', 'instalments', 'installments', 'rent'],
      ['pain', 'painful', 'hurt', 'hurts', 'painless'],
      ['risk', 'risks', 'dangerous', 'burn', 'burns', 'effects'],
      ['long', 'duration', 'sessions'],
      ['warranty', 'guarantee'],
      ['training', 'course', 'courses', 'academy', 'certificate'],
      ['hair', 'epilation', 'depilation'],
      ['tattoo', 'tattoos', 'ink'],
      ['wrinkles', 'ageing', 'aging', 'rejuvenation', 'tightening'],
      ['pimples', 'spots', 'acne', 'blemishes', 'blackheads'],
      ['scar', 'scars', 'scarring'],
      ['fat', 'contouring', 'sculpting', 'cryolipolysis', 'slimming'],
      ['pigmentation', 'pigment', 'melasma', 'sunspots'],
      ['maintenance', 'service', 'repair', 'spare'],
      ['buy', 'buying', 'purchase', 'order'],
      ['approval', 'certification', 'ce', 'mdr'],
      ['sun', 'tan', 'tanned', 'sunbed', 'summer'],
      ['pregnant', 'pregnancy', 'breastfeeding'],
      ['men', 'man', 'beard', 'male'],
      ['profitable', 'profit', 'revenue', 'payback', 'roi'],
      ['aftercare', 'healing', 'recovery']
    ]
  };
  /* Verschreiber und Diktat-Varianten der Geraetenamen, gilt in allen Sprachen */
  var ALIAS = { debian: 'deweon', devion: 'deweon', deveon: 'deweon', dewion: 'deweon', devon: 'deweon', devian: 'deweon', dewon: 'deweon',
    piccolo: 'picolo', pikolo: 'picolo', picollo: 'picolo', pikkolo: 'picolo',
    frako: 'fraco', fracco: 'fraco', cryomaster: 'kyromaster', kryomaster: 'kyromaster',
    velalift: 'velaslift', eufeus: 'eupheus', eupheos: 'eupheus', tulex: 'tulix' };
  var SYN = new Map(), SYNKEYS = [];
  /* Wortlisten der uebrigen Sprachen liegen in assets/siac-wissen-syn-<sprache>.js */
  function initSyn() {
    SYN = new Map();
    /* Hauttypen: Ziffern und roemische Zahlen gleich behandeln */
    var groups = (GROUPS[lang] || (window.__siacWissenSyn || {})[lang] || []).concat([['1', 'i'], ['2', 'ii'], ['3', 'iii'], ['4', 'iv'], ['5', 'v'], ['6', 'vi']]);
    groups.forEach(function (g) {
      var n = g.map(norm);
      n.forEach(function (w) {
        var set = SYN.get(w) || [];
        n.forEach(function (o) { if (o !== w && set.indexOf(o) < 0) set.push(o); });
        SYN.set(w, set);
      });
    });
    SYNKEYS = Array.from(SYN.keys());
  }
  /* Wortliste zu einem Suchwort, auch fuer gebeugte Formen (Suchwort beginnt mit einem Listenwort oder umgekehrt) */
  function synFor(q) {
    var s = SYN.get(q); if (s) return s;
    var min = CJK_RE.test(q) ? 2 : 4, L = q.length, i, k;
    if (L < min) return null;
    for (i = 0; i < SYNKEYS.length; i++) {
      k = SYNKEYS[i];
      if (k.length >= min && (q.lastIndexOf(k, 0) === 0 ? L <= k.length + 3 : (k.lastIndexOf(q, 0) === 0 && L >= k.length - 2))) return SYN.get(k).concat([k]);
    }
    return null;
  }

  /* ---------- Index ---------- */
  function Index() { this.vocab = new Map(); this.vlist = []; this.N = 0; }
  Index.prototype.add = function (id, text, w) {
    var t = tokens(text), i, p, n;
    for (i = 0; i < t.length; i++) {
      p = this.vocab.get(t[i]);
      if (!p) { p = []; this.vocab.set(t[i], p); }
      n = p.length;
      if (n && p[n - 2] === id) { if (p[n - 1] < w) p[n - 1] = w; } else p.push(id, w);
    }
  };
  Index.prototype.done = function (n) { this.N = n; this.vlist = Array.from(this.vocab.keys()); };

  function prefixLen(a, b) { var n = Math.min(a.length, b.length), i = 0; while (i < n && a.charCodeAt(i) === b.charCodeAt(i)) i++; return i; }
  /* Damerau-Levenshtein mit Abbruch ab max */
  function dist(a, b, max) {
    var la = a.length, lb = b.length;
    if (Math.abs(la - lb) > max) return max + 1;
    var prev2 = null, prev = new Array(lb + 1), cur, i, j, c, m, best;
    for (j = 0; j <= lb; j++) prev[j] = j;
    for (i = 1; i <= la; i++) {
      cur = new Array(lb + 1); cur[0] = i; best = i;
      for (j = 1; j <= lb; j++) {
        c = a.charCodeAt(i - 1) === b.charCodeAt(j - 1) ? 0 : 1;
        m = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + c);
        if (i > 1 && j > 1 && a.charCodeAt(i - 1) === b.charCodeAt(j - 2) && a.charCodeAt(i - 2) === b.charCodeAt(j - 1)) m = Math.min(m, prev2[j - 2] + 1);
        cur[j] = m; if (m < best) best = m;
      }
      if (best > max) return max + 1;
      prev2 = prev; prev = cur;
    }
    return prev[lb];
  }

  /* Schreibvarianten eines Suchworts: Geraetenamen-Verschreiber, arabischer Artikel, hebraeische Vorsilbe */
  function variants(ix, q) {
    var out = [q], a = ALIAS[q];
    if (a && !ix.vocab.has(q)) return [a];
    var m = q.match(/^(?:وال|بال|لل|ال)(.{3,})$/);
    if (m) out.push(m[1]);
    else if (/^[א-ת]{4,}$/.test(q) && /^[הובלמשכ]/.test(q)) out.push(q.slice(1));
    /* Tippfehler: kommt das Wort nirgends vor (auch nicht als Wortanfang), das haeufigste aehnliche Wort mitsuchen */
    var L = q.length;
    if (L >= 4 && !ix.vocab.has(q) && !synFor(q)) {
      var V = ix.vlist, md = L >= 8 ? 2 : 1, best = null, bd = 9, bn = 0, k, v, d, n, pre = false;
      for (k = 0; k < V.length; k++) {
        v = V[k];
        if (v.lastIndexOf(q, 0) === 0) { pre = true; break; }
        if (Math.abs(v.length - L) > md) continue;
        d = dist(q, v, md); if (d > md) continue;
        n = ix.vocab.get(v).length;
        if (d < bd || (d === bd && n > bn)) { best = v; bd = d; bn = n; }
      }
      if (!pre && best) out.push(best);
    }
    return out;
  }
  /* Liefert je Dokument die beste Trefferguete fuer ein Suchwort */
  function expand(ix, q0, last, hl) {
    var out = new Map(), strong = new Set();
    variants(ix, q0).forEach(function (q, vi) {
      var L = q.length, cjk = CJK_RE.test(q), base = vi ? 0.88 : 1;
      var exact = ix.vocab.has(q), syn = synFor(q), smin = cjk ? 2 : 5, V = ix.vlist, k, v, ql, p, i, w, lv, md, d;
      var stem = L >= 7 ? q.slice(0, L - 2) : null;
      for (k = 0; k < V.length; k++) {
        v = V[k]; ql = 0; lv = v.length;
        if (v === q) ql = 1;
        else if (L >= 2 || cjk) {
          if (lv > L && (last || L >= 4 || cjk) && v.lastIndexOf(q, 0) === 0) ql = (last ? 0.95 : 0.85) * (0.8 + 0.2 * L / lv);
          else if ((L >= 4 || (cjk && L >= 2)) && v.indexOf(q) > 0) ql = 0.5;
          else if (L >= 5 && lv >= 5 && (w = prefixLen(q, v)) >= Math.max(4, Math.ceil(0.6 * Math.max(L, lv))) && L - w <= 4 && lv - w <= 4) ql = 0.6;
          else if (!syn && L >= (exact ? 5 : 4) && Math.abs(lv - L) <= 2) {
            md = !exact && L >= 8 ? 2 : 1; d = dist(q, v, md);
            if (d <= md) ql = exact ? 0.45 : (d === 1 ? 0.8 : 0.6);
          }
          if (!ql && stem && lv > L && v.indexOf(stem) >= 0) ql = 0.4;
          /* zusammengesetzte Woerter in der Eingabe: das Wort im Text ist Anfang oder Ende des Suchworts */
          if (!ql && lv >= 4 && L >= lv + 3) {
            if (q.lastIndexOf(v, 0) === 0) ql = 0.3 + 0.3 * lv / L;
            else if (lv >= 5 && q.indexOf(v, L - lv) === L - lv) ql = 0.3 + 0.3 * lv / L;
          }
        }
        if (!ql && syn) {
          for (i = 0; i < syn.length; i++) {
            if (syn[i] === v) { ql = 0.7; break; }
            if (syn[i].length >= smin && lv > syn[i].length && v.lastIndexOf(syn[i], 0) === 0) ql = 0.5;
          }
        }
        if (!ql) continue;
        /* schwache Treffer (nur Wortteil) zaehlen weder fuer die Haeufigkeit noch fuer die Hervorhebung */
        d = ql >= 0.5;
        if (hl && d) hl.add(v);
        ql *= base;
        p = ix.vocab.get(v);
        for (i = 0; i < p.length; i += 2) {
          w = ql * p[i + 1];
          if ((out.get(p[i]) || 0) < w) out.set(p[i], w);
          if (d) strong.add(p[i]);
        }
      }
    });
    out.df = strong.size || out.size;
    return out;
  }

  function search(ix, toks, hl) {
    var per = [], idf = [], sum = 0, miss = 0, i;
    for (i = 0; i < toks.length; i++) {
      var one = new Set(), m = expand(ix, toks[i], i === toks.length - 1, one);
      /* Hervorheben: keine Allerweltswoerter (sehr haeufig; bei kurzen Woertern wie was, ein, the strenger) */
      if (hl && (toks.length === 1 || m.df <= (toks[i].length > 3 || CJK_RE.test(toks[i]) ? 0.5 : 0.12) * ix.N)) one.forEach(function (v) { hl.add(v); });
      if (!m.size) { miss++; sum += Math.log(1 + ix.N) + 0.05; continue; }
      per.push(m); idf.push(Math.log(1 + ix.N / (1 + m.df)) + 0.05);
    }
    if (!per.length) return [];
    for (i = 0; i < idf.length; i++) sum += idf[i];
    var acc = new Map();
    per.forEach(function (m, j) {
      m.forEach(function (w, id) {
        var s = acc.get(id); if (!s) { s = [0, 0]; acc.set(id, s); }
        s[0] += idf[j] * w; s[1] += idf[j];
      });
    });
    var res = [], maxCov = 0;
    acc.forEach(function (s, id) {
      var cov = s[1] / sum; if (cov > maxCov) maxCov = cov;
      res.push({ id: id, cov: cov, score: s[0] * cov * cov });
    });
    return res.filter(function (r) { return r.cov >= maxCov - 0.2; });
  }

  /* ---------- Oberflaeche ---------- */
  function el(tag, cls, text) { var e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; }
  function marked(parent, text, hl) {
    var re = new RegExp(WORD_RE.source, 'gu'), last = 0, m;
    while ((m = re.exec(text))) {
      if (hl.has(norm(m[0]))) {
        if (m.index > last) parent.appendChild(document.createTextNode(text.slice(last, m.index)));
        parent.appendChild(el('mark', null, m[0])); last = m.index + m[0].length;
      }
    }
    if (last < text.length) parent.appendChild(document.createTextNode(text.slice(last)));
    return last > 0;
  }
  function snippet(answer, hl) {
    var flat = answer.replace(/\s+/g, ' ').trim(), re = new RegExp(WORD_RE.source, 'gu'), m, pos = -1;
    while ((m = re.exec(flat))) { if (hl.has(norm(m[0]))) { pos = m.index; break; } }
    if (pos < 90) return flat.length > 190 ? flat.slice(0, 190).replace(/\s+\S*$/, '') + ' …' : flat;
    var start = flat.lastIndexOf('. ', pos); start = start < 0 || pos - start > 110 ? flat.indexOf(' ', pos - 70) + 1 : start + 2;
    var s = flat.slice(start, start + 190);
    return (start > 0 ? '… ' : '') + (start + 190 < flat.length ? s.replace(/\s+\S*$/, '') + ' …' : s);
  }
  function store(key, val) {
    try {
      if (val === undefined) return window.localStorage.getItem(key);
      window.localStorage.setItem(key, val);
    } catch (e) { return null; }
  }

  /* Adressen nur ueber den Pfad vergleichen (absolute und relative Links gleich behandeln) */
  function pathOf(u) { try { return new URL(u, location.href).pathname.replace(/\/+$/, '') || '/'; } catch (e) { return u; } }

  var shared = {};  /* je Index-URL ein gemeinsamer Ladevorgang */
  function loadIndex(url) {
    if (shared[url]) return shared[url];
    var ck = 'swx:i:' + url, cached = null;
    try { cached = window.sessionStorage.getItem(ck); } catch (e) {}
    shared[url] = (cached ? Promise.resolve(cached) : fetch(url, { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.text();
    }).then(function (html) {
      var m = html.match(/<script[^>]*data-swx-index[^>]*>([\s\S]*?)<\/script>/);
      if (!m) throw new Error('kein Index');
      try { window.sessionStorage.setItem(ck, m[1]); } catch (e) {}
      return m[1];
    })).then(function (txt) { return JSON.parse(txt); });
    shared[url].catch(function () { delete shared[url]; });
    return shared[url];
  }

  function init(root) {
    var cfg = {};
    try { cfg = JSON.parse(root.querySelector('[data-swx-cfg]').textContent); } catch (e) { return; }
    lang = cfg.l || document.documentElement.lang || 'de';
    lang = lang.slice(0, 2).toLowerCase();
    initSyn();
    var S = cfg.s || [], input = root.querySelector('.swx__in'), panel = root.querySelector('.swx__panel'),
      nav = root.querySelector('[data-swx-nav]'), resBox = root.querySelector('[data-swx-res]'), clear = root.querySelector('.swx__x'),
      recentBox = root.querySelector('[data-swx-recent]'), none = root.querySelector('[data-swx-none]');
    if (!input || !panel) return;

    /* Themen aus dem Markup */
    var topics = [], tix = new Index(), byUrl = {};
    Array.prototype.forEach.call(root.querySelectorAll('a[data-swx-t]'), function (a, i) {
      var t = { id: i, a: a, url: a.getAttribute('href'), short: a.textContent.trim(), long: a.getAttribute('data-long') || '', kat: a.getAttribute('data-kat') || '', here: a.getAttribute('aria-current') === 'page', n: 0 };
      topics.push(t); byUrl[pathOf(t.url)] = t;
      tix.add(i, t.short, 10); tix.add(i, t.long, 7); tix.add(i, t.kat, 3);
    });
    tix.done(topics.length);

    var fix = null, faqs = [], state = 'idle', shown = 7, active = -1, lastQ = '';

    function ensureIndex() {
      loadSyn();
      if (state !== 'idle' || !cfg.r) return;
      state = 'loading';
      loadIndex(cfg.r + '?section_id=' + 'siac-wissen-index').then(function (data) {
        var ix = new Index(), map = (data.t || []).map(function (u) { return byUrl[pathOf(u)] || null; });
        (data.f || []).forEach(function (f, i) {
          var t = map[f[0]]; if (!t) return;
          var id = faqs.length; faqs.push({ t: t, n: f[1], q: f[2], a: f[3] }); t.n++;
          ix.add(id, f[2], 10); ix.add(id, t.short, 5); ix.add(id, t.long, 4); ix.add(id, t.kat, 2); ix.add(id, f[3], 2.5);
        });
        ix.done(faqs.length); fix = ix; state = 'ready';
        if (input.value.trim()) run();
      }).catch(function () { state = 'failed'; if (input.value.trim()) run(); });
    }

    /* Wortliste der Sprache nachladen (Deutsch und Englisch stecken in dieser Datei) */
    function loadSyn() {
      if (GROUPS[lang] || (window.__siacWissenSyn || {})[lang] || !SELF || root.__swxSyn) return;
      root.__swxSyn = true;
      var sc = document.createElement('script');
      sc.src = SELF.replace(/siac-wissen-suche\.js.*$/, 'siac-wissen-syn-' + lang + '.js');
      sc.async = true;
      sc.onload = function () { initSyn(); if (input.value.trim()) run(); };
      document.head.appendChild(sc);
    }

    function fit() {
      var vv = window.visualViewport; if (!vv || panel.hidden) return;
      var b = root.querySelector('.swx__box').getBoundingClientRect().bottom - (vv.offsetTop || 0);
      panel.style.maxHeight = Math.max(260, Math.min(580, vv.height - b - 18)) + 'px';
    }
    function open() { if (panel.hidden) { panel.hidden = false; input.setAttribute('aria-expanded', 'true'); root.classList.add('is-open'); } fit(); }
    function close() { if (!panel.hidden) { panel.hidden = true; input.setAttribute('aria-expanded', 'false'); root.classList.remove('is-open'); setActive(-1); } }
    function opts() { return resBox.hidden ? [] : Array.prototype.slice.call(resBox.querySelectorAll('a.swx__opt')); }
    function setActive(i) {
      var o = opts(); active = i;
      o.forEach(function (a, k) { a.classList.toggle('is-on', k === i); });
      if (i >= 0 && o[i]) { input.setAttribute('aria-activedescendant', o[i].id); o[i].scrollIntoView({ block: 'nearest' }); }
      else input.removeAttribute('aria-activedescendant');
    }

    function recent() {
      if (!recentBox) return;
      var list = []; try { list = JSON.parse(store('swx:r:' + lang) || '[]'); } catch (e) {}
      var wrap = recentBox.querySelector('[data-swx-chips]'); if (!wrap) return;
      wrap.textContent = '';
      list.slice(0, 5).forEach(function (q) {
        var b = el('button', 'swx__chip', q); b.type = 'button';
        b.addEventListener('click', function () { input.value = q; input.focus(); run(); });
        wrap.appendChild(b);
      });
      recentBox.hidden = !list.length;
    }
    function remember(q) {
      q = q.trim(); if (q.length < 3) return;
      var list = []; try { list = JSON.parse(store('swx:r:' + lang) || '[]'); } catch (e) {}
      list = [q].concat(list.filter(function (x) { return x.toLowerCase() !== q.toLowerCase(); })).slice(0, 5);
      store('swx:r:' + lang, JSON.stringify(list));
    }

    function group(label) { var g = el('div', 'swx__grp'); g.appendChild(el('p', 'swx__cap', label)); var ul = el('ul', 'swx__list'); g.appendChild(ul); resBox.appendChild(g); return ul; }
    function optLink(href, n) {
      var a = el('a', 'swx__opt'); a.href = href; a.id = root.id + '-o' + n; a.setAttribute('role', 'option');
      a.addEventListener('click', function (ev) { remember(input.value); go(a, ev); });
      return a;
    }
    function go(a, ev) {
      var u; try { u = new URL(a.href, location.href); } catch (e) { return; }
      if (u.pathname === location.pathname && u.hash) {
        if (ev) ev.preventDefault();
        close(); input.blur();
        var target = document.getElementById(decodeURIComponent(u.hash.slice(1)));
        if (location.hash === u.hash) { if (target) target.scrollIntoView({ block: 'start' }); }
        else location.hash = u.hash;
      }
    }

    function run() {
      var raw = input.value, q = raw.trim(), toks = tokens(q);
      clear.hidden = !raw;
      var minLen = CJK_RE.test(q) ? 1 : 2;
      if (norm(q).length < minLen || !toks.length) { resBox.hidden = true; nav.hidden = false; none.hidden = true; recent(); setActive(-1); lastQ = ''; return; }
      if (q !== lastQ) { shown = 7; lastQ = q; }
      var hl = new Set(), nq = toks.join(' ');
      var tres = search(tix, toks, hl).sort(function (a, b) { return b.score - a.score; });
      var fres = [];
      if (fix) {
        fres = search(fix, toks, hl);
        var tb = {}, tmax = tres.length ? tres[0].score : 0;
        tres.forEach(function (r) { if (r.cov >= 0.55) tb[r.id] = r.score / tmax; });
        fres.forEach(function (r) {
          var f = faqs[r.id], qn = tokens(f.q).join(' ');
          if (nq.length > 3 && qn.indexOf(nq) >= 0) r.score *= 1.5;
          if (f.t.here) r.score *= 1.06;
          r.score *= (1 + 0.35 * (tb[f.t.id] || 0)) * (1 + (toks.length === 1 ? 0.5 : 0.2) / f.n);
        });
        fres.sort(function (a, b) { return b.score - a.score; });
        if (fres.length) { var top = fres[0].score; fres = fres.filter(function (r) { return r.score >= top * 0.22; }).slice(0, 40); }
      }
      /* Themen: Titel-Treffer, sonst das Thema, zu dem die meisten der besten Fragen gehoeren */
      var tshow = [];
      if (tres.length) { var tt = tres[0].score; tshow = tres.filter(function (r) { return r.score >= tt * 0.45 && r.cov >= 0.55; }).slice(0, 3).map(function (r) { return topics[r.id]; }); }
      if (tshow.length < 3 && fres.length) {
        var cnt = {}, sc = {}, order = [];
        fres.slice(0, 10).forEach(function (r) { var id = faqs[r.id].t.id; if (!cnt[id]) { cnt[id] = 0; sc[id] = 0; order.push(id); } cnt[id]++; sc[id] += r.score; });
        order.sort(function (a, b) { return sc[b] - sc[a]; });
        order.forEach(function (id) { if (cnt[id] >= 3 && tshow.length < 3 && tshow.indexOf(topics[id]) < 0) tshow.push(topics[id]); });
      }

      resBox.textContent = ''; var n = 0;
      if (fres.length) {
        var ul = group(S[4] || 'Fragen');
        fres.slice(0, shown).forEach(function (r) {
          var f = faqs[r.id], li = el('li'), a = optLink(f.t.url + '#frage-' + f.n, n++);
          var qs = el('span', 'swx__q'); marked(qs, f.q, hl); a.appendChild(qs);
          var sn = el('span', 'swx__s'); marked(sn, snippet(f.a, hl), hl); a.appendChild(sn);
          var me = el('span', 'swx__m', f.t.short);
          if (f.t.here && S[8]) { me.appendChild(el('span', 'swx__here', S[8])); }
          a.appendChild(me); li.appendChild(a); ul.appendChild(li);
        });
        if (fres.length > shown) {
          var more = el('button', 'swx__more', S[6] || 'Mehr'); more.type = 'button';
          more.addEventListener('click', function () { shown += 8; run(); input.focus(); });
          resBox.appendChild(more);
        }
      }
      if (tshow.length) {
        var ul2 = group(S[3] || 'Themen'); ul2.classList.add('swx__list--t');
        tshow.forEach(function (t) {
          var li = el('li'), a = optLink(t.url, n++); a.classList.add('swx__opt--t');
          var qs = el('span', 'swx__q'); marked(qs, t.short, hl); a.appendChild(qs);
          var meta = t.kat; if (t.n && cfg.c) meta += ' · ' + cfg.c.replace('{n}', t.n);
          a.appendChild(el('span', 'swx__m', meta)); li.appendChild(a); ul2.appendChild(li);
        });
      }
      var loading = !fix && state === 'loading';
      if (loading) resBox.appendChild(el('div', 'swx__load ignore-empty'));
      var empty = !fres.length && !tshow.length && !loading;
      none.hidden = !empty; resBox.hidden = empty; nav.hidden = !empty;
      if (recentBox) recentBox.hidden = true;
      setActive(-1);
    }

    /* Themenwechsel: Kategorie-Reiter */
    var tabs = Array.prototype.slice.call(root.querySelectorAll('.swx__tab')), lists = Array.prototype.slice.call(root.querySelectorAll('[data-swx-list]'));
    function pick(i) {
      tabs.forEach(function (t, k) { t.setAttribute('aria-pressed', k === i ? 'true' : 'false'); });
      lists.forEach(function (l, k) { l.hidden = k !== i; });
    }
    tabs.forEach(function (t, i) { t.addEventListener('click', function () { pick(i); }); });

    var timer = 0;
    input.addEventListener('input', function () { ensureIndex(); open(); clearTimeout(timer); timer = setTimeout(run, 70); });
    input.addEventListener('focus', function () {
      ensureIndex(); open(); run();
      if (window.matchMedia('(max-width: 749px)').matches) {
        var r = root.getBoundingClientRect();
        if (r.top > window.innerHeight * 0.3) setTimeout(function () { root.scrollIntoView({ block: 'start', behavior: 'smooth' }); }, 60);
      }
    });
    input.addEventListener('click', function () { open(); });
    root.addEventListener('pointerenter', ensureIndex, { once: true });
    root.addEventListener('touchstart', ensureIndex, { once: true, passive: true });
    input.addEventListener('keydown', function (ev) {
      var o = opts();
      if (ev.key === 'ArrowDown') { ev.preventDefault(); open(); if (o.length) setActive((active + 1) % o.length); }
      else if (ev.key === 'ArrowUp') { ev.preventDefault(); if (o.length) setActive(active <= 0 ? o.length - 1 : active - 1); }
      else if (ev.key === 'Enter') {
        ev.preventDefault();
        var a = o[active >= 0 ? active : 0];
        if (a) { remember(input.value); var u = new URL(a.href, location.href); if (u.pathname === location.pathname && u.hash) go(a, null); else location.href = a.href; }
      }
      else if (ev.key === 'Escape') { if (input.value) { input.value = ''; run(); } else { close(); input.blur(); } }
    });
    clear.addEventListener('click', function () { input.value = ''; input.focus(); run(); });
    document.addEventListener('pointerdown', function (ev) { if (!root.contains(ev.target)) close(); });
    root.addEventListener('focusout', function (ev) { if (ev.relatedTarget && !root.contains(ev.relatedTarget)) close(); });
    if (window.visualViewport) { window.visualViewport.addEventListener('resize', fit); window.visualViewport.addEventListener('scroll', fit); }
    window.addEventListener('scroll', fit, { passive: true });
    var form = root.querySelector('form'); if (form) form.addEventListener('submit', function (ev) { ev.preventDefault(); });
    root.classList.add('is-ready');
  }

  function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-swx]'), function (r) { if (!r.__swx) { r.__swx = true; init(r); } }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
  window.__siacWissenSucheTest = { norm: norm, tokens: tokens };
})();
